import { useEffect } from "react";


export default function MobileMenuToggle() {
    useEffect(() => {
        console.log("✅ MobileMenuToggle mounted");

        const navbar = () => document.getElementById("navbar");
        const openButton = () =>
            document.querySelector(".navbar-toggler.open-btn");
        const closeButton = () => document.querySelector("#navbar .menu-close");

        const openMenu = () => {
            const el = navbar();
            if (!el) return;
            el.classList.add("active");
            el.style.left = "0px";
            el.style.opacity = "1";
            el.style.visibility = "visible";
            document.body.classList.add("mobile-menu-open");
            console.log("✅ Menu opened");
        };

        const closeMenu = () => {
            const el = navbar();
            if (!el) return;
            el.classList.remove("active");
            el.style.left = "-320px";
            el.style.opacity = "0";
            el.style.visibility = "hidden";
            document.body.classList.remove("mobile-menu-open");
            console.log("❌ Menu closed");
        };

        // Attach listeners directly
        const btn = openButton();
        const close = closeButton();

        if (btn) btn.addEventListener("click", openMenu);
        if (close) close.addEventListener("click", closeMenu);

        // Close on nav link click
        document.querySelectorAll("#navbar a").forEach((link) => {
            link.addEventListener("click", closeMenu);
        });

        // ✅ Close when clicking outside
        const handleOutsideClick = (e) => {
            const el = navbar();
            if (
                el &&
                el.classList.contains("active") &&
                !el.contains(e.target) &&
                !e.target.closest(".navbar-toggler.open-btn")
            ) {
                closeMenu();
            }
        };
        document.addEventListener("click", handleOutsideClick);

        // Cleanup listeners
        return () => {
            if (btn) btn.removeEventListener("click", openMenu);
            if (close) close.removeEventListener("click", closeMenu);
            document.querySelectorAll("#navbar a").forEach((link) => {
                link.removeEventListener("click", closeMenu);
            });
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return null;
}
